// 파이어베이스 앱 객체 모듈 가져오기
import firebase from 'firebase/app'
// 파이어베이스 패키지 모듈 가져오기
import 'firebase/firestore'

// 파이어베이스 DB를 초기화
const oFirebase = firebase.initializeApp({
  // 파이어베이스 콘솔에서 복사하여 붙여넣기
  apiKey: "AIzaSyBWGJp3Vui59JkEPDiIbNAAEJdLQwntyLE",
  authDomain: "pwa-offline-sync.firebaseapp.com",
  projectId: "pwa-offline-sync",
});

// 파이어베이스 인증 객체 공개
export const oFirebaseAuth = oFirebase.auth;

// 파이어스토어 스토어 오프라인 캐시 사용
export const oPicturesinDB = firebase.firestore()
oPicturesinDB.enablePersistence({
  synchronizeTabs: true // 브라우저 열린 탭과 동기화
}).catch(err => console.log(err))